import { createFileRoute } from '@tanstack/react-router'

import { ControlRoom } from '@/pages/ControlRoom/ControlRoom'

const VALID_TABS = ['queue', 'operations'] as const
type ValidTab = (typeof VALID_TABS)[number]

const isValidTab = (value: string): value is ValidTab =>
  (VALID_TABS as readonly string[]).includes(value)

export const Route = createFileRoute('/_app/control-room/')({
  component: ControlRoom,
  validateSearch: (search: Record<string, unknown>) => {
    const result: { tab?: ValidTab; actions?: 'open' } = {}
    const tabValue = typeof search.tab === 'string' ? search.tab : undefined
    if (tabValue && isValidTab(tabValue)) {
      result.tab = tabValue
    }
    if (search.actions === 'open') {
      result.actions = 'open'
    }
    return result
  },
})
